const apiBaseUrl = import.meta.env.VITE_API_BASE_URL
import axios from 'axios'
import { getToken } from '../utils/auth'

// 创建不带 token 的 axios 实例
const publicInstance = axios.create({
  baseURL: apiBaseUrl,
  timeout: 10000,
})

// 创建带 token 的 axios 实例
const instance = axios.create({
  baseURL: apiBaseUrl,
  timeout: 10000,
})

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// API 路由配置
const api = {
  // 登录相关（使用不带 token 的实例）
  login: (data: any) => publicInstance.post('/admin', data),
  validateToken: () => instance.post('/token/validation'),
  // 添加修改密码接口
  changePassword: (data: { username: string; old_password: string; new_password: string }) =>
    instance.post('/admin/changepwd', data),

  // 会议相关
  meetings: {
    list: () => instance.get('/meetings'),
    create: (data: any) => instance.post('/meetings', data),
    update: (id: string, data: any) => instance.put(`/meetings/${id}`, data),
    delete: (id: string) => instance.delete(`/meetings/${id}`),
    detail: (id: string) => instance.get(`/meetings/${id}`),
    scores: {
      get: (id: string) => instance.get(`/meetings/${id}/scores`),
      submit: (id: string, data: any) => instance.post(`/meetings/${id}/scores`, data),
    },
    // 添加获取参与者列表接口
    getParticipants: (id: string) => publicInstance.get(`/meetings/${id}/participants`),
    scoring: (data: { meeting_id: string; judge: string; participant: string; score: number }) =>
      publicInstance.post('/meetings/score', data),
  },
  templates: {
    list: () => instance.get('/templates'),
    detail: (id: string) => instance.get(`/templates/${id}`),
    updateItem: (id: number, data: any) => {
      instance.put(`/templates/items/${id}`, data)
    },
    createItem: (data: any) => instance.post('/templates/items', data),
    deleteItem: (id: number) => instance.delete(`/templates/items/${id}`),
    // 添加获取模板ID列表的方法
    getIds: () => instance.get('/templates/ids'),
  },
}

export default api
